// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { POI, POIType } from "generated/mos/poi";
import { Codec, DecodeContext, RemoteObject, WebRPCError, decodeMessageRepeated, stripTypePropertyDeep } from "generated/webrpc";

export namespace GetPOIRequest {
  export const refName = "mos.poi_access.GetPOIRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly poiRef: { readonly typename: 'mos.poi.POI', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    poiRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_access.GetPOIRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["poiRef"] = v["poiRef"];
      return out as any as Entity;
    }
  }();
}

export namespace GetPOIResponse {
  export const refName = "mos.poi_access.GetPOIResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly poi: POI.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    poi: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["poi"] = POI.codec.encode(v.poi);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_access.GetPOIResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["poi"] = ctx.decode(POI.codec, v["poi"], "poi");
      return out as any as Entity;
    }
  }();
}

export namespace GetPOITypeRequest {
  export const refName = "mos.poi_access.GetPOITypeRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly poiTypeRef: { readonly typename: 'mos.poi.POIType', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    poiTypeRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_access.GetPOITypeRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["poiTypeRef"] = v["poiTypeRef"];
      return out as any as Entity;
    }
  }();
}

export namespace GetPOITypeResponse {
  export const refName = "mos.poi_access.GetPOITypeResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly poiType: POIType.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    poiType: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_access.GetPOITypeResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["poiType"] = ctx.decode(POIType.codec, v["poiType"], "poiType");
      return out as any as Entity;
    }
  }();
}

export namespace ListPOITypesRequest {
  export const refName = "mos.poi_access.ListPOITypesRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
  }
  export const defaults: Entity = {
    type: refName,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_access.ListPOITypesRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      return out as any as Entity;
    }
  }();
}

export namespace ListPOITypesResponse {
  export const refName = "mos.poi_access.ListPOITypesResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly poiTypes: ReadonlyArray<POIType.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    poiTypes: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_access.ListPOITypesResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["poiTypes"] = decodeMessageRepeated(ctx, POIType.codec, v["poiTypes"], "poiTypes");
      return out as any as Entity;
    }
  }();
}

export namespace ListPOIsRequest {
  export const refName = "mos.poi_access.ListPOIsRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
  }
  export const defaults: Entity = {
    type: refName,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_access.ListPOIsRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      return out as any as Entity;
    }
  }();
}

export namespace ListPOIsResponse {
  export const refName = "mos.poi_access.ListPOIsResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly pois: ReadonlyArray<POI.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    pois: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["pois"] = [];
      for (const item of v.pois) {
        obj["pois"].push(POI.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.poi_access.ListPOIsResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["pois"] = decodeMessageRepeated(ctx, POI.codec, v["pois"], "pois");
      return out as any as Entity;
    }
  }();
}

